import { get } from 'lodash';

export const getBlogStats = (state) => state.blogStats;
export const getTotalPublicationsCount = (state) => get(getBlogStats(state), 'publicationsCount.total');
